'use client';
/* External Imports */
import { Link } from '@chakra-ui/next-js';
import { Box, Divider, Flex, Text } from '@chakra-ui/react';
// import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';
// import StructuredTextParser from '@app-ps/Utility/StructuredTextParser';
import config from '@config';
import ContentArea from '../ContentArea';
import { modifyDatoImgUrlToStatic } from '../utils';

/**
 * Renders Footer Component
 * @param {Obj} footerData
 * @param {Str} region
 * @param {Str} language
 * @returns {ReactElement} Footer
 */

const Footer = ({ region, language, footerData }) => {

  const aboutSection = footerData?.allIsoMainMenus?.[0];
  const usefulSection = footerData?.allIsoMainMenus?.[1];
  const contactSection = footerData?.allIsoMainMenus?.[2];
  const terms = footerData?.allIsoMainMenus?.[3];
  const privacy = footerData?.allIsoMainMenus?.[4];
  const allRights = footerData?.allIsoMainMenus?.[5];

  const workshop = contactSection?.submenuItems?.[0];
  const production = contactSection?.submenuItems?.[1];
  const facebook = contactSection?.submenuItems?.[2];
  const youtube = contactSection?.submenuItems?.[3];
  const instagram = contactSection?.submenuItems?.[4];

  // return <></>

  return (
    <Flex
      width={'100%'}
      height={{ base: 'auto', md: '128px' }} bg={'#FFFFFF'}
      flexDir={{ base: 'column', md: "row" }}
    >
      <Box display={'flex'} w={{ base: '100%', md: '15%' }} alignItems={'center'} justifyContent={{ base: "center", md: 'right' }}>
        <LazyLoadImageComponent
          mt={{ base: "1.5rem", md: '0px' }}
          mb={{ base: '10px', md: "0px" }}
          src={modifyDatoImgUrlToStatic(footerData?.allIsoMainMenus?.[0]?.icon?.url)}
          w={{ base: '59.5px', md: '54.4px', lg: '72px' }}
          h={{ base: '48.14px', md: '44px', lg: "56px" }}
          mr={{ base: '0rem', md: '0rem', lg: '0rem', xl: '-1rem', '2xl': '-10rem' }}
        />
      </Box>
      <Box id='footerText' display={'flex'} w={{ base: '100%', md: '85%' }} alignItems={'center'} justifyContent={'right'}
      ml={{base:'0px', md: '30px', lg:"0px"}}>
        <ContentArea
          width={{ base: '277px', md: '620px', lg: 'auto' }}
          maxW={'100%'}
          tAlign={{ base: 'center', md: 'left' }}
          pt={'0px'}
          mt={{ base: '0px', md: '30px' }}
          fontFamily={'var(--FedraSansStd-book)'}
          color={'#000000'}
          mainContent={footerData?.allIsoMainMenus?.[0]?.body}
          sectionContent={footerData?.allIsoMainMenus?.[0]}
          font={{ base: '14px', md: '14px', lg: '16px' }}
          fontWeight={400}
          lineHeight={{ base: '26px', md: '20px', lg: '30px' }}
        />
      </Box>
      <style>
        {` #footerText a {
          text-decoration: underline;
        }
        #footerText a:hover {
          color: #B7870C !important;
        }`}
      </style>
    </Flex>
  );
};

export default Footer;
